import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'edu-parent-view',
  templateUrl: './parent-view.component.html',
  styleUrls: ['./parent-view.component.scss']
})
export class ParentViewComponent implements OnInit {
  jwt: string | null;
  hasError: boolean = false;
  username: string = null;
  fullName: string = null;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {

  }
  ngOnInit() {
    this.username = this.activatedRoute.snapshot.queryParamMap.get('userName');
    this.fullName = this.activatedRoute.snapshot.queryParamMap.get('fullName');
  }
  logo(): string {
    return environment.assets.logo;
  }
}
